import React from 'react';
import NavigationBar from '../containers/NavigationBar';

// The Header creates links that can be used to navigate
// between routes.
const Header = () => (
  <header>
    <NavigationBar />
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js